import { theme } from "../../theme.js";

export default function Grid({children, minWidth="300px"}) {
  return (
    <div style={{ ...styles(theme).infoGrid, gridTemplateColumns: `repeat(auto-fill, minmax(${minWidth}, 1fr))` }}>{children}</div>
  );
}

const styles = (theme) => ({
    infoGrid: {
    display: "grid",
    gap: theme.spacing.md,
    width: "100%",
  },
});
